;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export const ROUTES = {
	AGENTS: "/agents",
	AUTOMATIONS: "/automations",
	AUTOMATIONS_SUPPORT: "/automations/support",
	CREATE_AUTOMATION: "/automations/create",
	EDIT_AUTOMATION: "/automations/:automationId/edit",
	FORGOT_PASSWORD: "/forgot-password",
	HOME: "/",
	LEADERBOARD: "/leaderboard",
	ONBOARDING: "/onboarding",
	PROFILE: "/profile",
	SETTINGS: "/settings",
	VIEW_AUTOMATION: "/automations/:automationId",
	VIEW_AUTOMATION_EXECUTION: "/automations/:automationId",
	VOIP: "/voip",
} as const;

export const PUBLIC_ROUTES = [
	ROUTES.HOME,
	ROUTES.ONBOARDING,
	ROUTES.FORGOT_PASSWORD,
] as const;

export const PROTECTED_ROUTES = [
	ROUTES.SETTINGS,
	ROUTES.PROFILE,
	ROUTES.LEADERBOARD,
	ROUTES.AGENTS,
	ROUTES.AUTOMATIONS,
	ROUTES.CREATE_AUTOMATION,
	ROUTES.EDIT_AUTOMATION,
	ROUTES.VIEW_AUTOMATION,
	ROUTES.VOIP,
] as const;
